import { parseToFloat } from "@/services/Formatting.js";

const paymentDiscountMixin = originalAmount => ({
  data() {
    return {
      discounts: []
    };
  },
  computed: {
    originalAmount() {
      return this[originalAmount];
    },
    finalAmount() {
      return this.originalAmount - this.totalDiscounts;
    },
    totalDiscounts() {
      return this.discounts.reduce(this.calculateTotalDiscounts, 0);
    },
    areDiscountsApplied() {
      return this.discounts.length > 0;
    }
  },
  methods: {
    addDiscount(Name, Amount) {
      Amount = parseToFloat(Amount);
      if (this.discounts.length < 1) {
        this.discounts.push({ Name, Amount });
        return;
      }

      const discountIndex = this.getDiscountIndex(Name);

      if (discountIndex < 0) {
        this.discounts.push({ Name, Amount });
        return;
      }

      this.discounts[discountIndex].Amount = Amount;
    },
    getDiscountIndex(Name) {
      return this.discounts.findIndex(d => d.Name === Name);
    },
    getDiscount(Name) {
      const discountIndex = this.getDiscountIndex(Name);
      return discountIndex < 0 ? null : this.discounts[discountIndex];
    },
    removeDiscount(Name) {
      const discountIndex = this.getDiscountIndex(Name);
      this.discounts.splice(discountIndex, 1);
    },
    calculateTotalDiscounts(total, discount) {
      return total + discount.Amount;
    }
  }
});

export default paymentDiscountMixin;
